






// @ is an alias to /src
import Vue from 'vue';
import ApiRequest from '@/util/apiRequest';

import { API_MOTION_QUERY } from '@/util/config';

export default Vue.extend({
  watch: {
    $route(to, from) {
      document.title = to.meta.title || 'Motions Database';
    },
  },
});
